import { GetServerSideProps } from 'next';

import { useSearchParams } from 'next/navigation';
import AuthoredPageRoutes from '@/components/authored-page-routes/authored-page-routes';
import { PLP_PAGE_TYPE, banners } from '@/data/constants';
import { PreRenderProps } from '@/pages/_app';
import { getPlpViewDefinition } from '@/ssr/view-definition-plp-page-query';
import { SRPFeedbackProvider, useSRPRelevanceFeedback } from '@iceberg/srp-relevance-feedback';
import { useCommonContextProps, useDetermineBanner } from '@/hooks';

import { fetchDataAndHandleErrors, withTokenRefresh } from '@/utils/ssr-utils';

export const getServerSideProps: GetServerSideProps<PreRenderProps> = withTokenRefresh(async (context: any) => {
  const data = await fetchDataAndHandleErrors(context, getPlpViewDefinition, PLP_PAGE_TYPE.SEARCH);
  return { props: data };
});

const SRPRelevanceFeedbackInitializer = () => {
  useSRPRelevanceFeedback();
  return null;
};

const SearchResultRoutes = (props: any) => {
  const { isSrpFeedbackEnabled } = useCommonContextProps();
  const isPharmaprix = useDetermineBanner();
  const banner = isPharmaprix ? banners.PHARMAPRIX : banners.SHOPPERS;
  const searchParams = useSearchParams();
  const urlSearchParams = searchParams ? new URLSearchParams(searchParams.toString()) : null;

  return (
    <SRPFeedbackProvider
      enabled={Boolean(isSrpFeedbackEnabled)}
      bannerDomain={`${banner}.ca`}
      searchParams={urlSearchParams}
    >
      <AuthoredPageRoutes {...props} />
      <SRPRelevanceFeedbackInitializer />
    </SRPFeedbackProvider>
  );
};

export default SearchResultRoutes;
